import { render, staticRenderFns } from "./DoorForm.vue?vue&type=template&id=b4fd284c"
import script from "./DoorForm.vue?vue&type=script&lang=js"
export * from "./DoorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports